import React from 'react';
import PropTypes from 'prop-types';

import {Button, Typography} from 'views/components';
import {translate} from 'views/module';

const SimpleRefreshWidget = (props) => {
  const {numRefresh, setNumRefresh, setLastUpdatedAt} = props;

  const handleRefresh = () => {
    const nextLastUpdatedAt = new Date().toISOString();

    setNumRefresh(numRefresh + 1);
    setLastUpdatedAt(nextLastUpdatedAt);
  };

  return (
    <Button
      variant='outlined'
      onClick={handleRefresh}
      sx={{
        'boxSizing': 'border-box',
        'minWidth': '63px',
        'height': '32px',
        'px': '10px',
        'py': '8px',
        'border': '1px solid #D8D3CC',
        'borderRadius': '7px',
        'backgroundColor': '#FFFFFF',
        'color': '#6B6760',
        'boxShadow': 'none',
        'textTransform': 'none',
        '&:hover': {
          'border': '1px solid #D8D3CC',
          'backgroundColor': '#F7F4EF',
          'boxShadow': 'none',
        },
        '&:disabled': {
          'border': '1px solid #E7E2DB',
          'backgroundColor': '#F8F6F2',
          'color': '#B4AEA6',
        },
      }}
    >
      <Typography
        sx={{
          fontStyle: 'normal',
          fontWeight: 400,
          fontSize: '12px',
          lineHeight: '16px',
          color: 'inherit',
        }}
      >
        {translate('generic.Refresh')}
      </Typography>
    </Button>
  );
};

SimpleRefreshWidget.propTypes = {
  numRefresh: PropTypes.number.isRequired,
  setLastUpdatedAt: PropTypes.func.isRequired,
  setNumRefresh: PropTypes.func.isRequired,
};

export default React.memo(SimpleRefreshWidget);
